import { Component, Input, OnChanges } from "@angular/core";
import { Role } from "@common/ADAPT.Common.Model/organisation/role";
import { RoleLocation } from "@common/ADAPT.Common.Model/organisation/role-location";
import { RxjsBreezeService } from "@common/lib/data/rxjs-breeze.service";
import { SortUtilities } from "@common/lib/utilities/sort-utilities";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { CommonIntegratedArchitectureFrameworkService } from "@org-common/lib/architecture/common-integrated-architecture-framework.service";
import { lastValueFrom } from "rxjs";

@Component({
    selector: "adapt-role-teams-panel",
    standalone: false,
    templateUrl: "./role-teams-panel.component.html",
})
export class RoleTeamsPanelComponent extends BaseComponent implements OnChanges {
    @Input() public role?: Role;

    public roleTeamLocations: RoleLocation[] = [];

    constructor(
        private commonArchService: CommonIntegratedArchitectureFrameworkService,
        rxjsBreezeService: RxjsBreezeService,
    ) {
        super();

        rxjsBreezeService.entityTypeChanged(RoleLocation)
            .pipe(this.takeUntilDestroyed())
            .subscribe(() => this.updateRoleLocations());
    }

    public async ngOnChanges() {
        await this.updateRoleLocations();
    }

    private async updateRoleLocations() {
        if (!this.role) {
            return;
        }

        this.roleTeamLocations = (await lastValueFrom(this.commonArchService.getTeamRoleLocationsForRole(this.role.roleId)))
            .sort(SortUtilities.getSortByFieldFunction<RoleLocation>("team.teamTypeConfiguration.ordinal", "team.name"));
    }
}
